module.exports = __webpack_public_path__ + "img/sem-imagem-publicidade2.af7518e2.jpg";